// ----------------------------------------------------------------------
// import { LinkIcon } from "@heroicons/react/24/outline";
// const HEADINGS = ['Heading 1', 'Heading 2', 'Heading 3', 'Heading 4', 'Heading 5', 'Heading 6'];

export const formats = [
  'align',
  'background',
  'blockquote',
  'bold',
  'bullet',
  'code',
  'code-block',
  'color',
  'direction',
  'font',
  'formula',
  'header',
  'image',
  'indent',
  'italic',
  'link',
  'list',
  'script',
  'size',
  'strike',
  'table',
  'underline',
  'video',
];

type EditorToolbarProps = {
  id: string;
  isSimple?: boolean;
  showLists?: boolean;
  // link: () => void;
};

export default function Toolbar({ id, showLists }: EditorToolbarProps) {
  return (
    <div id={id}>
      {/* <select className="ql-header" defaultValue="" onChange={(e) => e.persist()}>
        <option value="1"></option>
        <option value="2"></option>
        <option value=""></option>
      </select> */}
      <button className="ql-bold"></button>
      <button className="ql-italic"></button>
      <button className="ql-underline"></button>
      {/* <button className="ql-strike" /> */}
      {/* <button className="ql-blockquote" /> */}
      {showLists && <button className="ql-list" value="bullet" />}
      {/* {showLists && <button className="ql-list" value="ordered" />} */}
      {/* <button className="ql-link" onClick={link}></button> */}
      {/* <button className="ql-link"></button> */}
      {/* <button className="ql-insertLink"><div /></button> */}
    </div>
  );
}
